import { jsx as S } from "react/jsx-runtime";
import h, { useState as x, useCallback as f, useEffect as D } from "react";
import { c as G } from "../../index-C3-ZVs5E.js";
import { InputSizeEnum as a, InputThemeEnum as u } from "./types.js";
import { useEffectOnce as X } from "../utils.js";
import '../../assets/Input.css';const b = "_input_1s7pi_2", C = "_sizeSM_1s7pi_9", N = "_sizeMD_1s7pi_15", R = "_sizeLG_1s7pi_21", j = "_sizeXL_1s7pi_28", k = "_primary_1s7pi_35", H = "_secondary_1s7pi_53", I = "_transparent_1s7pi_71", t = {
  input: b,
  sizeSM: C,
  sizeMD: N,
  sizeLG: R,
  sizeXL: j,
  primary: k,
  secondary: H,
  transparent: I
}, J = ({
  value: _ = "",
  inputTheme: m,
  inputSize: r,
  formatter: p,
  onInput: n,
  autoFocus: z,
  selectAllInitially: l,
  type: i,
  ...y
}) => {
  const [e, d] = x(_), L = h.useRef(null), E = G({
    [t.input]: !0,
    [t.primary]: m === u.primary,
    [t.transparent]: m === u.transparent,
    [t.secondary]: m === u.secondary,
    [t.sizeSM]: r === a.sm,
    [t.sizeMD]: r === a.md,
    [t.sizeLG]: r === a.lg,
    [t.sizeXL]: r === a.xl
  }), M = p !== void 0, o = f(
    (s) => s ? M ? p(s) ?? "" : s : "",
    [p, M]
  ), g = f(
    (s) => {
      if (!(s.target instanceof HTMLInputElement))
        return;
      const { value: c } = s.target;
      d(o(c)), n == null || n(c);
    },
    [o, n]
  );
  return X(
    f(() => {
      const s = L.current;
      if (z && s) {
        s.focus();
        const c = (e == null ? void 0 : e.length) ?? 0;
        (i === "text" || i === "number") && (s.selectionStart = s.selectionEnd = c), l && (s.selectionStart = 0);
      }
    }, [z, e == null ? void 0 : e.length, l, i])
  ), D(() => {
    d(o(_));
  }, [o, _]), /* @__PURE__ */ S(
    "input",
    {
      ...y,
      ref: L,
      className: E,
      autoComplete: "off",
      onInput: g,
      value: e,
      type: i
    }
  );
};
export {
  J as Input
};
